<template>
    <div>
        <div class="card card-gray mt-3" v-for="(value, key) in filledValues">
            <div class="card-body">
                <div class="row">
                    <div class="col-11">
                        <input type="text"
                               class="form-control"
                               v-model="filledValues[key]"
                               @input="input(key, $event.target.value)"
                               @remove="removeText(key)">
                    </div>
                    <div class="col-1 text-end align-content-end">
                        <button @click="removeText(key)"
                                class="btn btn-outline-secondary mt-auto"
                                :title="$t('form.buttonRemove')">
                            <span class="fas fa-times"></span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-3">
            <button class="btn btn-outline-primary" @click="addValue()">
                Přidat
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import {Control} from '@/composables/Control';
import {defineComponent, PropType, ref, watch} from 'vue';

export default defineComponent({
    props: {
        value: {
            type: Array as PropType<string[] | null>,
            default: null,
        },
        validate: {
            type: Boolean,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
    },
    emits: ['input', 'validated'],
    setup(props, {emit}) {
        const filledValues = ref<string[]>([]);

        function getValue(): string[] {
            return filledValues.value.filter(value => value !== '');
        }

        const {updateValue, isInvalid} = Control<string[]>(props, emit, {
            getValue,
        });

        watch(filledValues, () => {
            updateValue();
        }, {deep: true});

        // created logic
        if (props.value !== null) {
            filledValues.value = props.value.map(value => value);
        }

        function input(key: number, value: string): void {
            filledValues.value[key] = value;
        }

        function addValue(): void {
            filledValues.value.push('');
        }

        function removeText(key: number): void {
            filledValues.value.splice(key, 1);
        }

        return {
            filledValues,
            input,
            addValue,
            removeText,
            isInvalid,
        };
    },
});
</script>
